import React, {Component} from 'react';
import {connect} from 'react-redux'

import HtmlPage from 'views/htmlPage/HtmlPage';
import Login from 'views/login/Login';

import './landing.scss';

class Landing extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        console.log("this.props.view", this.props.view)
        return (
          <HtmlPage className="screen-landing">
            <div className="content-landing">
                <div className="content-landing-inner">
                    <Login />
                </div>
            </div>
          </HtmlPage>
        );
    }
}

export default connect((state, props) => {
    return {

    }
},(dispatch, props) => {
    return {

    }
})(Landing)



// WEBPACK FOOTER //
// ./src/components/screens/landing/Landing.js